/**
 * The parser's vocabulary and the Location Tree ids it resolves to. Static files rather than part of the bundle:
 * together they weigh ~250 KB, and only visitors in the B version who focus the box ever need them.
 * Dated names, because public/ files are cached by name – a new vocab ships as a new file.
 */
const VOCAB_URL = '/own-words-search/vocab-20261026.json';
const LOCATION_IDS_URL = '/own-words-search/location-ids-20261104.json';

let dataPromise = null;

const fetchJson = async (url) => {
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`Own-words search: ${url} returned HTTP ${response.status}`);
  }

  return response.json();
};

/**
 * @returns {Promise<{ vocab: object, locationIds: Object<string, { id: number, areas: Object<string, number> }> }>}
 */
export const loadData = () => {
  if (!dataPromise) {
    dataPromise = Promise.all([fetchJson(VOCAB_URL), fetchJson(LOCATION_IDS_URL)])
      .then(([vocab, locationIds]) => ({ vocab, locationIds }))
      .catch((error) => {
        dataPromise = null; // a later focus may try again

        throw error;
      });
  }

  return dataPromise;
};

const CURRENCY_SYMBOLS = { GB: '£', IE: '€' };

/**
 * Same three on every page and market, with no place names – only the currency follows the market.
 *
 * @returns {string[]}
 */
export const exampleSearches = (countryCode) => {
  const currency = CURRENCY_SYMBOLS[countryCode] ?? '$';

  return [
    `Birthday party for 40 with a DJ, under ${currency}3k`,
    'Private room for a team dinner, 20 people next Friday',
    'Rooftop bar for Christmas drinks, around 60 guests',
  ];
};
